import React from 'react';
import { Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { X as XIcon } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-sky-700 dark:bg-sky-800 shadow-lg mt-auto">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-green-500 dark:text-green-300 mb-12">
            CONNECT WITH US
          </h2>

          <div className="flex flex-wrap justify-center items-center gap-8 mb-8">
            {/* Phone */}
            <a 
              href="tel:0798765432" 
              className="flex items-center space-x-2 text-green-600 dark:text-green-300 hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
            >
              <Phone className="h-5 w-5" />
              <span>0798-765432</span>
            </a>

            {/* Email */}
            <a 
              href="mailto:support@jumuiyaenergy.com" 
              className="flex items-center space-x-2 text-green-600 dark:text-green-300 hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
            >
              <Mail className="h-5 w-5" />
              <span>info@jumuiyaenergy.com</span>
            </a>

            {/* Facebook */}
            <a 
              href="https://facebook.com/jumuiyaenergy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 hover:text-green-800 transition-colors"
            >
              <Facebook className="h-5 w-5" />
              <span className="font-semibold">Facebook</span>
            </a>

            {/* X */}
            <a 
              href="https://x.com/gobebakenya" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 dark:text-green-300 hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
            >
              <XIcon className="h-5 w-5" />
              <span>@jumuiyaenergy</span>
            </a>

            {/* Instagram */}
            <a 
              href="https://instagram.com/jumuiyaenergy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 dark:text-green-300 hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
            >
              <Instagram className="h-5 w-5" />
              <span>jumuiyaenergy</span>
            </a>
          </div>

          <div className="text-sm text-green-500 dark:text-green-400">
            Copyright © 2025 JUMUIYAENERGY
          </div>
        </div>
      </div>
    </footer>
  );
};
